import { render, staticRenderFns } from "./DuplicateCampaignModal.vue?vue&type=template&id=d316ec1c&"
import script from "./DuplicateCampaignModal.vue?vue&type=script&lang=js&"
export * from "./DuplicateCampaignModal.vue?vue&type=script&lang=js&"
import style0 from "./DuplicateCampaignModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports